import React from "react";
import { useNavigate } from "react-router-dom";

interface CardResumoProps {
  titulo: string;
  valor: string;
}

export interface DashboardFinanceiroProps {
  titulo: string;
  subtitulo: string;
  receitaTotal: string;
  clientesAtivos: string;
  pagamentosPendentes: string;
  rotaRelatorio: string;
}

const CardResumo: React.FC<CardResumoProps> = ({ titulo, valor }) => (
  <div className="bg-white p-6 rounded-lg shadow">
    <p className="text-sm text-gray-500">{titulo}</p>
    <p className="mt-2 text-2xl font-bold text-[#29306a]">{valor}</p>
  </div>
);

const DashboardFinanceiro: React.FC<DashboardFinanceiroProps> = ({
  titulo,
  subtitulo,
  receitaTotal,
  clientesAtivos,
  pagamentosPendentes,
  rotaRelatorio,
}) => {
  const navigate = useNavigate();
 
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-[#29306a]">{titulo}</h1>
        <p className="text-sm text-gray-500">{subtitulo}</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <CardResumo titulo="Receita Total" valor={receitaTotal} />
        <CardResumo titulo="Clientes Ativos" valor={clientesAtivos} />
        <CardResumo titulo="Pagamentos Pendentes" valor={pagamentosPendentes} />
      </div>

      <div className="bg-white p-6 rounded-lg shadow flex items-center justify-between">
        <div>
          <h2 className="text-lg font-semibold text-[#29306a]">
            Relatórios Financeiros
          </h2>
          <p className="text-sm text-gray-500">
            Consulte pagamentos, planos e faturamento
          </p>
        </div>

        <button
          onClick={() => navigate(rotaRelatorio)}
          className="bg-[#32bef0] text-white px-5 py-2 rounded-md hover:bg-[#2ba8d8]"
        >
          Ver Relatórios
        </button>
      </div>
    </div>
  );
};

export default DashboardFinanceiro;
